import { formatSummaryFeature } from '~app/pages/Pricing/lib/PackageFeatures';
import { SummaryFeatureRuleMap } from '~app/pages/Pricing/transformers/summary/types';
import { Packages } from '~shared/constants/pricing';
import { DisplayFeatureStatic } from '~shared/types/pricing/features';
import FeatureRules from './featureRules';

/**
 * feature rules for treatment 1 and treatment 2, GROW-2792
 */
const FeatureRulesT1T2: SummaryFeatureRuleMap = {
  ...FeatureRules,
  grow_2792_question_types: (_, { packageName }) => {
    let obj: DisplayFeatureStatic = {};
    if (packageName && [Packages.Basic].includes(packageName)) {
      obj = formatSummaryFeature('grow_2792_basic_question_types');
    } else {
      obj = formatSummaryFeature(
        packageName && [Packages.FormsAnnual, Packages.FormsMonthly].includes(packageName)
          ? 'grow_2792_forms_question_types'
          : 'grow_2792_all_question_types_t1_t2'
      );
    }
    return obj;
  },
};

export default FeatureRulesT1T2;
